import { create } from "zustand";

// Store para manejar el creado, actualización y borrado de respuestas rápidas.
// quickReplies: Array de respuestas rápidas. Con el formato { id: string, name: string, message: string }
// setQuickReplies: Función para establecer el array completo de respuestas rápidas.
// add: Función para agregar una nueva respuesta rápida.
// update: Función para actualizar una respuesta rápida existente, donde newQuickReplyData contiene el objeto ya editado retornado por el backend.
// remove: Función para eliminar una respuesta rápida por su ID.

export const useQuickReplyStore = create((set) => ({
    quickReplies: [],

    setQuickReplies: (quickReplies) =>
        set({ quickReplies }),

    add: (newQuickReply) =>
        set((state) => ({
            quickReplies: [
                ...state.quickReplies,
                newQuickReply,
            ],
        })),

    update: (updatedQuickReply) =>
        set((state) => ({
            quickReplies: state.quickReplies.map((quickReply) =>
                quickReply.id === updatedQuickReply.id
                    ? updatedQuickReply
                    : quickReply
            ),
        })),

    remove: (quickReplyId) =>
        set((state) => ({
            quickReplies: state.quickReplies.filter(
                (quickReply) => quickReply.id !== quickReplyId
            ),
        })),
}));